import PluginAction from '../PluginAction';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';

export default class Plugin extends PluginAction {
  shouldExecute(...args) {
    return true;
  }

  async executeAsync(...args) {
    const [collection, {cat, q, search, sort, page}] = args;

    //"q" can defined custom query by project
    let catQuery = {};
    if (cat && collection === 'product') {
      const region = cat.split('-')[0];
      const attribute = cat.split('-')[1];
      catQuery = {
        $and: attribute
          ? [
              {
                region: {$regex: region},
              },
              {
                attribute: {$regex: attribute},
              },
            ]
          : [
              {
                region: {$regex: region},
              },
            ],
      };
    } else {
      catQuery = {};
    }
    const searchQuery = search ? {searchText: {$regex: search}} : {};
    const sortValue = sort ? [sort] : ['-created'];
    const pagingValue = page;
    const extraQueries = {};
    let projection = null;

    if (collection === 'product') {
      extraQueries.public = true;
    } else if (collection === 'Article_Default') {
      delete catQuery.labels;
      if (!cat) {
        catQuery.label = 'blog';
      } else {
        catQuery.label = {$regex: cat};
      }
      projection = {content: 0};
    }

    const resp = await JStorage.fetchDocuments(
      collection,
      {
        ...catQuery,
        ...searchQuery,
        ...extraQueries,
      },
      sortValue,
      pagingValue,
      projection, // if we're fetching Article, ignore the content
      {anonymous: true},
    );

    return resp;
  }
}
